// Namespace riêng cho khối CRM Order Information (CrmOrderInfo.vue).
// Text luôn hiển thị tiếng Việt, khớp 100% Figma (node 3644:1248, file 2sgFEdgIZaIpYDPpeHDuzF),
// bất kể ngôn ngữ hệ thống hiện tại (en/vi/de đều dùng chung nội dung file này).
// Tách riêng khỏi i18nRequest.js để tránh đụng key dùng chung với màn hình khác
// (VD: Status, Unit, Discount, TotalLabel... trùng tên nhưng khác nghĩa ở RequestDetail/LicenseInfo).
export default {
  CrmOrderInformation: 'Thông tin đơn hàng CRM',
  AutoCreateOrder: 'Tự động tạo đơn hàng',
  Delete: 'Xóa',
  AddRow: 'Thêm dòng',
  RequiredFieldNamed: '{field} không được để trống.',
  RequiredField: 'Vui lòng nhập đầy đủ thông tin',
  // Tiêu đề nhóm (I → VIII)
  CrmGeneralInformation: 'I. Thông tin chung',
  CrmCurrencyInformation: 'II. Thông tin tiền tệ',
  CrmProductInformation: 'III. Thông tin hàng hóa',
  CrmOrderExecutionStatus: 'IV. Tình trạng thực hiện đơn hàng',
  CrmInvoiceInformation: 'V. Thông tin hóa đơn',
  CrmDescriptionInformation: 'VI. Thông tin mô tả',
  // Figma ghi "VII" — lỗi đánh số của design. Theo doc.xlsx/spec.md (chốt PO, clarifications.md §C-5) = VIII.
  CrmSystemInformation: 'VIII. Thông tin hệ thống',

  // I. Thông tin chung
  OrderNumber: 'Số đơn hàng',
  SaleOrderDate: 'Ngày đặt hàng',
  Account: 'Khách hàng',
  LiquidateAmountOC: 'Giá trị thanh lý NT',
  LiquidateAmount: 'Giá trị thanh lý',
  OrderValueOC: 'Giá trị đơn hàng NT',
  OrderValue: 'Giá trị đơn hàng',
  DueDate: 'Hạn thanh toán',
  SaleOrderType: 'Loại đơn hàng',
  Description: 'Diễn giải',
  ParentOrder: 'Đơn hàng cha',
  PartnerType: 'Loại đối tác',

  // II. Thông tin tiền tệ
  UseCurrency: 'Sử dụng ngoại tệ',
  // Figma ghi "Đồng ngoại tệ" — chốt PO/BA dùng "Loại tiền" (clarifications.md §C-6, khớp doc.xlsx FieldName CurrencyTypeID).
  CurrencyType: 'Loại tiền',
  ExchangeRate: 'Tỷ giá',

  // III. Thông tin hàng hóa (cột bảng)
  ProductCode: 'Mã hàng hóa',
  Amount: 'Số lượng',
  UnitIDText: 'Đơn vị tính',
  UnitPrice: 'Đơn giá',
  ToCurrencyOC: 'Thành tiền NT',
  ToCurrency: 'Thành tiền',
  TotalAfterPromotion: 'Thành tiền sau giảm',
  DiscountPercent: 'Tỷ lệ chiết khấu (%)',
  DiscountOC: 'Tiền chiết khấu NT',
  Discount: 'Tiền chiết khấu',
  UnitPriceAfterDiscount: 'Đơn giá sau chiết khấu',
  ToCurrencyOCAfterDiscount: 'Thành tiền NT sau CK',
  ToCurrencyAfterDiscount: 'Thành tiền sau CK',
  TaxPercent: 'Thuế suất',
  TaxOC: 'Tiền thuế NT',
  QuantityByUnit: 'SL theo ĐVTC',
  TaxAmount: 'Tiền thuế',
  UnitPriceByUnit: 'Đơn giá theo ĐVTC',
  TotalOC: 'Tổng tiền NT',
  TotalLabel: 'Tổng tiền',

  // IV. Tình trạng thực hiện đơn hàng
  Status: 'Tình trạng',
  RevenueStatus: 'Tình trạng ghi doanh số',
  RecordDate: 'Ngày ghi số',
  DeliveryStatus: 'Tình trạng giao hàng',
  Activated: 'Đã kích hoạt',

  // V. Thông tin hóa đơn
  // Figma ghi "Khác hàng" (thiếu chữ "h" — lỗi chính tả design) — sửa đúng chính tả "Khách hàng".
  InvoiceCustomer: 'Khách hàng',
  Country: 'Quốc gia',
  Address: 'Địa chỉ',

  // VI. Thông tin mô tả
  SystemDescription: 'Mô tả',

  // VIII. Thông tin hệ thống
  Owner: 'Người thực hiện',
  Unit: 'Đơn vị',
  OwnerRole: 'Vai trò người thực hiện',
  SalesEmployee: 'Nhân viên được ghi DS',
  SalesUnit: 'Đơn vị được ghi DS',
  CreatedBy: 'Người tạo',

  // Option list (dropdown)
  CrmSaleOrderTypeNew: 'Bán mới',
  CrmSaleOrderTypeExtra: 'Bán thêm',
  CrmSaleOrderTypeUpgrade: 'Nâng cấp',
  CrmSaleOrderTypeRenew: 'Gia hạn/Cập nhật',
  CrmSaleOrderTypeTraining: 'Dịch vụ đào tạo',
  CrmSaleOrderTypeConsulting: 'Dịch vụ tư vấn triển khai',
  CrmSaleOrderTypeOther: 'Dịch vụ khác',
  CrmPartnerTypeNew: 'Đối tác mới',
  CrmPartnerTypeExisting: 'Đối tác cũ',
  CrmStatusNotExecuted: 'Chưa thực hiện',
  CrmStatusExecuting: 'Đang thực hiện',
  CrmStatusExecuted: 'Đã thực hiện',
  CrmStatusCanceled: 'Đã hủy bỏ',
  CrmRevenueStatusDraft: 'Bản nháp',
  CrmRevenueStatusRequested: 'Đề nghị ghi',
  CrmDeliveryStatusNotDelivered: 'Chưa giao hàng',
  CrmDeliveryStatusDelivering: 'Đang giao hàng',
  CrmDeliveryStatusDelivered: 'Đã giao hàng',
  // IMS
  ImsInformation: 'Thông tin yêu cầu IMS',
  AutoCreateIms: 'Tự động tạo yêu cầu',
  ImsHeaderTitle1: 'I. Thông tin cấp GPSD',
  ImsProduct: 'Sản phẩm',
  ImsRequestType: 'Loại yêu cầu',
  ImsWebAddress: 'Địa chỉ truy cập',
  ImsStartDate: 'Ngày bắt đầu',
  ImsNumOfUseMonth: 'Số tháng sử dụng',
  ImsEndDate: 'Ngày hết hạn',
  ImsAmount: 'Số tiền',
  ImsNumOfBranch: 'Số chi nhánh',
  ImsHeaderTitle2: 'II. Thông tin thuê bao',
  ImsSubNo: 'Mã thuê bao',
  ImsSubPro: 'Gói',
  ImsSubNumOfMonth: 'Số tháng',
  ImsSubEndDate: 'Ngày kết thúc',
  ImsSubDetail: 'Thông tin thiết bị & nghiệp vụ',
  ImsHeaderTitle3: 'III. Thông tin khách hàng',
  ImsPartner: 'Mã đại lý',
  ImsProj: 'Dự án bán hàng',
  ImsContactPer: 'Người liên hệ',
  ImsPos: 'Chức danh',
  ImsProNoun: 'Xưng hô',
  ImsTel: 'Điện thoại',
  ImsEmail: 'Email',
  ImsDeviceBusiness: 'Thông tin thiết bị và nghiệp vụ -',
  ImsTime: 'Thời gian',
  ImsDevice: 'Thiết bị',
  ImsBusiness: 'Nghiệp vụ/Tính năng',
  ImsDeviceType: 'Loại thiết bị',
  ImsQtyBuy: 'SL mua',
  ImsBusinessType: 'Loại nghiệp vụ/Tính năng',
  ImsSave: 'Lưu',
  ImsCancel: 'Hủy',
  ImsValidationError: 'Vui lòng kiểm tra thông tin thiết bị và nghiệp vụ.',

  // Cột checkbox động theo thị trường
  ImsSelfOrderingKiosk: 'Self-ordering KIOSK',
  ImsOnlineReservation: 'Online Reservation',
  ImsOrderOnline: 'Order online',
  ImsOrderAtTable: 'Order tại bàn',
  ImsLomas: 'Lomas',

  // Nhãn gói sản phẩm theo thị trường
  ImsPackageTrial: 'Trial',
  ImsPackageStarter: 'Starter',
  ImsPackageStandard: 'Standard',
  ImsPackageAdvanced: 'Advanced',
  ImsPackageProfessional: 'Professional',
  ImsPackageEnterprise: 'Enterprise',
  ImsRequestTypeNew: 'Bán mới',
  ImsRequestTypeRenewal: 'Gia hạn',
  ImsRequestTypeFree: 'Miễn phí',
  ProductsRequired: 'Thông tin hàng hóa không được để trống',
  RequiredBranchResource: 'Thông tin thuê bao không được để trống',
};
